import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductCreateModel, ProductServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { ModalService } from '../../../services/modal/modal.service';
import { AuthService } from '../../../services/auth/auth.service';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ToastrService } from '../../../services/toastr/toastr.service';
import { ErrorService } from '../../../services/error/error.service';

@Component({
    selector: 'app-modal-create-product',
    templateUrl: './modal-create-product.component.html',
    styleUrl: './modal-create-product.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ModalCreateProductComponent implements OnInit {
  public productForm: ProductCreateModel = new ProductCreateModel();

  @Output() changeState = new EventEmitter<boolean>(false);

  isLoadingSend: boolean = false;
  
  constructor(private toastrService: ToastrService, private errorService: ErrorService, private _productServiceProxy: ProductServiceProxy, private modalService: ModalService, private authService: AuthService, private destroyService: DestroyService) {
  }

  closeModal() {
    this.modalService.closeModal();
    this.clearFormData();
  }

  ngOnInit() {
    this.initialize()
  }

  initialize() {
    this.productForm.isEnabled = true;
    this.productForm.requireShipping = true;
  }

  createProduct() {
    this.isLoadingSend = true;
    this.productForm.companyId = this.authService.getCompanyId()
    this._productServiceProxy.create(this.productForm)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(() => {
        this.closeModal();
        this.changeState.emit(true);
        this.toastrService.showSuccessToastr('Товар успешно создан!');
        this.isLoadingSend = false;
      }, error => {
        this.errorService.handleError(error, 'Не удалось создать товар. Попробуйте позже.');
        this.isLoadingSend = false;
      });
  }
  clearFormData() {
    this.productForm = new ProductCreateModel();
    this.initialize();
  }
}
